/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { appControllerCreateTestPaymentPlan } from '../fn/operations/app-controller-create-test-payment-plan';
import { AppControllerCreateTestPaymentPlan$Params } from '../fn/operations/app-controller-create-test-payment-plan';
import { appControllerHandleEvents } from '../fn/operations/app-controller-handle-events';
import { AppControllerHandleEvents$Params } from '../fn/operations/app-controller-handle-events';
import { stripeWebhookControllerHandleWebhook } from '../fn/operations/stripe-webhook-controller-handle-webhook';
import { StripeWebhookControllerHandleWebhook$Params } from '../fn/operations/stripe-webhook-controller-handle-webhook';

@Injectable({ providedIn: 'root' })
export class ApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appControllerCreateTestPaymentPlan()` */
  static readonly AppControllerCreateTestPaymentPlanPath = '/keus-payments/test/create-payment-plan/{visitId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerCreateTestPaymentPlan()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerCreateTestPaymentPlan$Response(params: AppControllerCreateTestPaymentPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appControllerCreateTestPaymentPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerCreateTestPaymentPlan$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerCreateTestPaymentPlan(params: AppControllerCreateTestPaymentPlan$Params, context?: HttpContext): Observable<void> {
    return this.appControllerCreateTestPaymentPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appControllerHandleEvents()` */
  static readonly AppControllerHandleEventsPath = '/keus-payments/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvents$Response(params?: AppControllerHandleEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appControllerHandleEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvents(params?: AppControllerHandleEvents$Params, context?: HttpContext): Observable<void> {
    return this.appControllerHandleEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `stripeWebhookControllerHandleWebhook()` */
  static readonly StripeWebhookControllerHandleWebhookPath = '/keus-payments/stripe/webhook';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stripeWebhookControllerHandleWebhook()` instead.
   *
   * This method doesn't expect any request body.
   */
  stripeWebhookControllerHandleWebhook$Response(params: StripeWebhookControllerHandleWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return stripeWebhookControllerHandleWebhook(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stripeWebhookControllerHandleWebhook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stripeWebhookControllerHandleWebhook(params: StripeWebhookControllerHandleWebhook$Params, context?: HttpContext): Observable<void> {
    return this.stripeWebhookControllerHandleWebhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
